import { useEffect, useState } from "react"
import type { SuccessFetch } from "types"
import { useApi } from "utils"
import { CashFowShortermSchema } from "../../types"

type CashFlowShortermType = {
  year_month: string
  location_id: string
}
export function useCashFlowShortermList(params?: CashFlowShortermType) {
  const api = useApi()
  const [data, setData] = useState<CashFowShortermSchema | null>(null)
  const [isLoading, setLoading] = useState<boolean>(false)

  const refetch = (params: CashFlowShortermType): void => { 
    setLoading(true)
    const isLocation = params.location_id !== "" ? params.location_id : null

    api.get("/cashflowshortterm/cashflow_short_term/", { params: { ...params, location_id: isLocation }})
    .then((res: SuccessFetch<{ payload: CashFowShortermSchema }>) => setData(res.data.payload))
    .catch(() => setData(null))
    .finally(() => setLoading(false))
  }

  useEffect(() => {
    const isLocation = params?.location_id !== "" ? params?.location_id : null
    setLoading(true)
  
    api.get("/cashflowshortterm/cashflow_short_term/", { params: { ...params, location_id: isLocation }})
    .then((res: SuccessFetch<{ payload: CashFowShortermSchema }>) => setData(res.data.payload))
    .catch(() => setData(null))
    .finally(() => setLoading(false))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { data, isLoading, refetch }
}